module.exports = "/images/london-24.jpg";